import React, { Suspense } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { LoggerContextProvider } from '@dodobrands/react-logger';
import { Layout } from 'antd';
import styled, { ThemeProvider } from 'styled-components';

import { FaviconProvider } from 'app/providers/FaviconProvider';
import { logger } from 'shared/lib/logger/logger';
import { Footer } from 'shared/ui/Layout/Footer/Footer';
import { Header } from 'shared/ui/Layout/Header';
import { I18nInitializer } from './providers/I18nInitializer';
import { RootRoutes } from './routes';
import { store } from './store';
import { theme } from './theme';
import { Main } from './ui/Main';

import './index.css';
import 'antd/dist/reset.css';

export const LayoutStyled = styled(Layout)`
	background-color: #fff;
`;

export const Root: React.FC = () => (
	<LoggerContextProvider loggerInstanceRef={logger}>
		<I18nInitializer defaultLanguage='ru-RU' languages={[`ru-RU`, `en-GB`]}>
			<Suspense fallback={<div>Loading marketplace...</div>}>
				<ThemeProvider theme={theme}>
					<Provider store={store}>
						<FaviconProvider>
							<BrowserRouter>
								<LayoutStyled>
									<Main>
										<Header />
										<RootRoutes />
										<Footer />
									</Main>
								</LayoutStyled>
							</BrowserRouter>
						</FaviconProvider>
					</Provider>
				</ThemeProvider>
			</Suspense>
		</I18nInitializer>
	</LoggerContextProvider>
);
